import { render, staticRenderFns } from "./PccOrderAgreementPropertiesEdit.vue?vue&type=template&id=60e2e39b&scoped=true&"
import script from "./PccOrderAgreementPropertiesEdit.vue?vue&type=script&lang=js&"
export * from "./PccOrderAgreementPropertiesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e2e39b",
  null
  
)

export default component.exports